import {
  packagingTypesSchema,
  packagingTypeSchema,
  shippingSettingsSchema,
  type PackagingTypeWrite,
  type ShippingSettings,
} from '@erp/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api-client';
export function usePackagingTypes(enabled = true) {
  return useQuery({
    queryKey: ['packaging-types'],
    queryFn: () => apiFetch('/api/v1/settings/packaging-types', packagingTypesSchema),
    enabled,
  });
}
export function useShippingSettings() {
  return useQuery({
    queryKey: ['shipping-settings'],
    queryFn: () => apiFetch('/api/v1/settings/shipping-summary', shippingSettingsSchema),
  });
}
export function useSaveShippingSettings() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: ShippingSettings) =>
      apiFetch('/api/v1/settings/shipping-summary', shippingSettingsSchema, {
        method: 'PUT',
        body: input,
      }),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: ['shipping-settings'] });
      await client.invalidateQueries({ queryKey: ['shipping-preview'] });
    },
  });
}
export function useSavePackagingType() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string | null; input: PackagingTypeWrite }) =>
      apiFetch(`/api/v1/settings/packaging-types${id ? `/${id}` : ''}`, packagingTypeSchema, {
        method: id ? 'PUT' : 'POST',
        body: input,
      }),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: ['packaging-types'] });
    },
  });
}
